/* This file is autogenerated, see readme.md for instructions */
import CustomersSegmentationSvgIcon from '@bloomreach/banana-theme/icons/customers-segmentation.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CustomersSegmentationIcon = forwardRef(
  (props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
    return (
      <Icon {...props} ref={forwardedRef}>
        <CustomersSegmentationSvgIcon />
      </Icon>
    );
  },
);

CustomersSegmentationIcon.displayName = 'CustomersSegmentationIcon';

export default CustomersSegmentationIcon;
